import axios from 'axios';
import {
    RECOMENDATION_COURSES_API,
    RECOMENDATION_COURSES_CODE,
    STATE_ACCOUNT_PENSION_APIKEY,
    URL_BACK,
    URL_EDUCATION,
    URL_LEGAL,
    URL_STATE_ACCOUNT_PENSION,
    URL_TAXES,
} from '../constants/api-constants';
import { axiosInstance } from './axios-instance';
import { getTokenContributor } from './contributor-interceptor';

const url = URL_BACK + '/afiliaciones/api/v1/';

export const getCertificateServices = async (
    numDoc,
    typeDoc,
    jwt,
    numDocumentCompany = '',
    typeDocumentCompany = ''
) => {
    return axiosInstance.get(
        `${url}consultaCertificado?numeroDocumento=${numDoc}&tipoDocumento=${typeDoc}&tipoDocumentoEmpresa=${typeDocumentCompany}&numeroDocumentoEmpresa=${numDocumentCompany}`,
        {
            headers: {
                Authorization: `${jwt}`,
            },
        }
    );
};

export const getRetiredCertificate = async (
    numDoc,
    typeDoc,
    jwt,
    isEmpresa,
    numDocumentCompany = '',
    typeDocumentCompany = ''
) => {
    return axiosInstance.get(
        `${url}consultarAfiliacionRetirado${
            isEmpresa ? 'Empresa' : ''
        }?tipoDocumentoEmpresa=${typeDocumentCompany}&numeroDocumentoEmpresa=${numDocumentCompany}&tipoDocumento=${typeDoc}&numeroDocumento=${numDoc}`,
        {
            headers: {
                Authorization: `${jwt}`,
            },
        }
    );
};

export const getExperienceCertificate = async (
    numDocumentCompany,
    typeDocumentCompany,
    jwt
) => {
    return axiosInstance.get(
        `${URL_BACK}/certificados/proveedores/api/v1/CertificadoExperiencia?numeroDocumento=${numDocumentCompany}&tipoDocumento=${typeDocumentCompany}`,
        {
            headers: {
                Authorization: `${jwt}`,
            },
        }
    );
};

export const getCollaboratorCredentialPDF = async (
    numDoc,
    typeDoc,
    numDocumentCompany = '',
    typeDocumentCompany = ''
) => {
    return axiosInstance.get(
        `${url}consultarCarnetPdfAfiliacionTitularTrabajador?numeroDocumento=${numDoc}&tipoDocumento=${typeDoc}&tipoDocumentoEmpresa=${typeDocumentCompany}&numeroDocumentoEmpresa=${numDocumentCompany}`
    );
};

export const getCollaboratorPACCredentialPDF = async (
    numDoc,
    typeDoc,
    numDocumentCompany = '',
    typeDocumentCompany = ''
) => {
    return axiosInstance.get(
        `${url}consultarCarnetPdfAfiliacionPacTrabajador?numeroDocumento=${numDoc}&tipoDocumento=${typeDoc}&tipoDocumentoEmpresa=${typeDocumentCompany}&numeroDocumentoEmpresa=${numDocumentCompany}`
    );
};

export const getMassiveCertificateService = async (payload, type) => {
    return axiosInstance.post(`${url}${type}`, payload);
};

export const getMassiveCertificateDownloadFile = async (payload) => {
    return axiosInstance.post(`${url}descargarMasivoAfiliacion`, payload);
};

export const getMassiveCredentialDownloadFile = async (payload) => {
    return axiosInstance.post(`${url}descargarMasivoAfiliacionCarnet`, payload);
};

export const getHistoricMassiveCertificate = async (
    numDoc,
    typeDoc,
    numDocumentCompany,
    typeDocumentCompany
) => {
    return axiosInstance.get(
        `${url}consultarTrabajadorMasivoHistorico?numeroDocumento=${numDoc}&numeroDocumentoEmpresa=${numDocumentCompany}&tipoDocumento=${typeDoc}&tipoDocumentoEmpresa=${typeDocumentCompany}`
    );
};

export const getCompensationReport = async (
    numDoc,
    typeDoc,
    typeConsult,
    anyo,
    accountingDocument,
    dateFrom,
    dateTo
) => {
    return axiosInstance.get(
        `${URL_BACK}/reportecompensacion/api/v1/consultaReporteCompensacion?anyo=${anyo}${
            accountingDocument && `&documentoContable=${accountingDocument}`
        }${dateFrom && `&fechaDesde=${dateFrom}`}${
            dateTo && `&fechaHasta=${dateTo}`
        }&numeroDocumento=${numDoc}&tipoConsulta=${typeConsult}&tipoDocumento=${typeDoc}`
    );
};

export const getListarAfiliadosCarnet = async (numDoc, typeDoc, jwt) => {
    return axiosInstance.get(
        `${url}listarAfiliadosCarnet?numeroDocumento=${numDoc}&tipoDocumento=${typeDoc}`,
        {
            headers: {
                Authorization: `${jwt}`,
            },
        }
    );
};

export const getConsultarCarnetPdfAfiliacionTitular = async (
    numDoc,
    typeDoc,
    jwt
) => {
    return axiosInstance.get(
        `${url}consultarCarnetPdfAfiliacionTitular?numeroDocumento=${numDoc}&tipoDocumento=${typeDoc}`,
        {
            headers: {
                Authorization: `${jwt}`,
            },
        }
    );
};

export const getConsultarCarnetPdfAfiliacionPAC = async (
    numDoc,
    typeDoc,
    jwt
) => {
    return axiosInstance.get(
        `${url}consultarCarnetPdfAfiliacionPac?numeroDocumentoPac=${numDoc}&tipoDocumentoPac=${typeDoc}`,
        {
            headers: {
                Authorization: `${jwt}`,
            },
        }
    );
};

export const getCertificateServicesEmployee = async (
    numDocumentCompany = '',
    typeDocumentCompany = '',
    jwt
) => {
    return axiosInstance.get(
        `${url}consultaCertificadoEmpleador?tipoDocumento=${typeDocumentCompany}&numeroDocumento=${numDocumentCompany}`,
        {
            headers: {
                Authorization: `${jwt}`,
            },
        }
    );
};

export const getDebtcertificate = async (idNumber, idType) => {
    return axiosInstance.get(
        `${URL_BACK}/certificadodeudas/api/v1/consultaCertificadoPersona?numeroDocumento=${idNumber}&tipoDocumento=${idType}`
    );
};

export const getWorkerSubsidyEnterpriseCertificate = async (
    idNumber,
    idType,
    period
) => {
    return axiosInstance.get(
        `${URL_BACK}/entregasubsidio/api/v1/consultaEntregaSubsidio?numeroDocumento=${idNumber}&periodo=${period}&tipoDocumento=${idType}`
    );
};

export const getMonetaryFee = async (
    idNumber,
    initialPeriod,
    finalPeriod,
    idType
) => {
    return axiosInstance.get(
        `${URL_BACK}/cuotamonetaria/api/v1/consultaCuotaMonetaria?numeroDocumento=${idNumber}&periodoFinal=${finalPeriod}&periodoInicial=${initialPeriod}&tipoDocumento=${idType}`
    );
};

export const getPeriodicalPaymentsBussines = async (
    idNumber,
    initialPeriod,
    finalPeriod,
    idType
) => {
    return axiosInstance.get(
        `${URL_BACK}/aportes/api/v1/consultaCertificadoPagoAporte?numeroDocumento=${idNumber}&tipoDocumento=${idType}&periodoInicio=${initialPeriod}&periodoFin=${finalPeriod}`
    );
};

export const getHouseAllowingCertificate = async (
    numeroDocumento,
    tipoDocumento,
    numeroFormulario
) => {
    return axiosInstance.get(
        `${URL_BACK}/postulacionvivienda/api/v1/consultaEstadoPostulacion?numeroDocumento=${numeroDocumento}&tipoDocumento=${tipoDocumento}${
            numeroFormulario && `&numeroFormulario=${numeroFormulario}`
        }`
    );
};

export const getCesdePaymentReference = async (
    tipoDocumento,
    numeroDocumento
) => {
    return axiosInstance.get(
        `${URL_BACK}/cesde/api/v1/getStudentByIdentification/${numeroDocumento}?identificationType=${tipoDocumento}`
    );
};

export const getDebtCertificateEnterprises = async (idNumber, idType) => {
    return axiosInstance.get(
        `${URL_BACK}/certificadodeudas/api/v1/consultaCertificadoEmpresa?numeroDocumento=${idNumber}&tipoDocumento=${idType}`
    );
};

export const getIncomeCertificate = async (idNumber) => {
    return axiosInstance.get(
        `${URL_BACK}/declaracionrenta/api/v1/certificado/${idNumber}`
    );
};

export const getDebtCertificateEnterprisesEmployee = async (
    idNumber,
    idType,
    idNumberEnterprise,
    idTypeEnterprise
) => {
    return axiosInstance.get(
        `${URL_BACK}/certificadodeudas/api/v1/consultaCertificadoTrabajador?numeroDocumento=${idNumber}&numeroDocumentoEmpresa=${idNumberEnterprise}&tipoDocumento=${idType}&tipoDocumentoEmpresa=${idTypeEnterprise}`
    );
};

export const getCertificateFosfecService = async ({
    numeroDocumento,
    periodoAnyos,
    tipoDocumento,
}) => {
    return axiosInstance.get(
        `${url}consultaCertificadoFosfec?numeroDocumento=${numeroDocumento}&periodoAnyos=${periodoAnyos}&tipoDocumento=${tipoDocumento}&applicationId=1`
    );
};

export const getCertificateRentSubisdyService = async ({
    numeroDocumento,
    tipoDocumento,
}) => {
    return axiosInstance.get(
        `${URL_BACK}/declaracionrentasubsidio/api/v1/declaracionRentaSubsidio?numeroDocumento=${numeroDocumento}&tipoDocumento=${tipoDocumento}&applicationId=1`
    );
};

export const getCertificateRetention = async ({
    anyo,
    bimester,
    id,
    certificateType,
    idType,
}) => {
    return axiosInstance.get(
        `${URL_TAXES}consultarCertificadoRetencion?anyo=${anyo}&bimestre=${bimester}&numeroDocumento=${id}&tipoCertificado=${certificateType}&tipoDocumento=${idType}`
    );
};

export const getPeriodosIva = async () => {
    return axiosInstance.get(`${URL_TAXES}listarPeriodosIva`);
};

export const getTiposCertificados = async () => {
    return axiosInstance.get(`${URL_TAXES}listarTiposCertificados`);
};

export const getAccountStatementReport = async ({
    tipoDocumento,
    numeroDocumento,
    jwt,
    isBussinesTab,
}) => {
    const config = {
        headers: {
            Authorization: `Bearer ${jwt}`,
        },
    };
    const url = `${URL_BACK}/aportes/api/v1/estado-cuenta-o-certificado`.concat(
        !isBussinesTab ? '-indUPensionado' : '',
        `?numeroDocumento=${numeroDocumento}&tipoDocumento=${tipoDocumento}`
    );

    return axios.get(url, config);
};

export const getNoAffiliation = async ({
    tipoDocumento,
    numeroDocumento,
}) => {
    return axiosInstance.get(
        `${URL_BACK}/afiliaciones/api/v1/consultarCertificadoNoAfiliado?tipoDocumento=${tipoDocumento}&numeroDocumento=${numeroDocumento}`
    );
};

export const getAccountStatementIndependientService = async ({
    documentType,
    documentNumber,
    jwt,
}) => {
    const config = {
        headers: {
            apikey: `${STATE_ACCOUNT_PENSION_APIKEY}`,
            //   Origin: "https://d1g7iof16pvjh1.cloudfront.net",
            Authorization: `Bearer ${jwt}`,
        },
    };
    return getTokenContributor.get(
        `${URL_STATE_ACCOUNT_PENSION}${documentType}/${documentNumber}`,
        config
    );
};

export const getListarEventosAsistencia = async (
    anyo,
    numeroDocumento,
    tipoDocumento
) => {
    return axiosInstance.get(
        `${URL_EDUCATION}listarEventosAsistencia?anyo=${anyo}&numeroDocumento=${numeroDocumento}&tipoDocumento=${tipoDocumento}`
    );
};

export const getCertificadoAsistencia = async (
    curso,
    fechaInicio,
    numeroDocumento,
    tipoDocumento
) => {
    return axiosInstance.get(
        `${URL_EDUCATION}consultarCertificadoAsistencia?curso=${curso}&numeroDocumento=${numeroDocumento}&fechaInicio=${fechaInicio}&tipoDocumento=${tipoDocumento}`
    );
};

export const getCoursesRecomendations = async (numeroDocumento) => {
    return axiosInstance.get(
        `${RECOMENDATION_COURSES_API}?code=${RECOMENDATION_COURSES_CODE}&nit=${numeroDocumento}`
    );
};

export const postLegal = async (document, documentType, email) => {
    const data = {
        document,
        documentType,
        email,
        id: 6,
    };
    return axiosInstance.post(`${URL_LEGAL}`, data);
};

export const getAccountStateConsult = async (document, documentType) => {
    return axiosInstance.get(
        `${URL_BACK}/creditoestadocuenta/api/v1/consultaCreditoEstadoCuenta?numeroDocumento=${document}&tipoDocumento=${documentType}`
    );
};

export const getAccountStateConsultCertificate = async (
    document,
    documentType,
    creditNumber
) => {
    return axiosInstance.get(
        `${URL_BACK}/creditoestadocuenta/api/v1/certificadoCreditoEstadoCuenta?numeroDocumento=${document}&tipoDocumento=${documentType}&numeroCredito=${creditNumber}`
    );
};

export const getHistoricalAfiliation = async (
    document,
    documentType,
    businessDocument,
    businessDocumentType,
    initialDate,
    finalDate
) => {
    return axiosInstance.get(
        `${URL_BACK}/afiliaciones/api/v1/consultarAfiliacionHistorico?fechaFin=${finalDate}&fechaInicio=${initialDate}&numeroDocumento=${document}${
            businessDocument !== ''
                ? `&numeroDocumentoEmpresa=${businessDocument}`
                : ''
        }&tipoDocumento=${documentType}${
            businessDocumentType !== ''
                ? `&tipoDocumentoEmpresa=${businessDocumentType}`
                : ''
        }`
    );
};

export const getDisbursementCertificate = async (
    documentNumber,
    documentType,
    creditNumber,
    user
) => {
    const urlParams = `?documentType=${documentType}&documentNumber=${documentNumber}&creditNumber=${creditNumber}&user=${user}`;
    const urlQuery = `${URL_BACK}/certificadocredito/api/v1/credits/receipt-payment${urlParams}`;
    return axiosInstance.get(urlQuery);
};

export const generatePDFPeaceAndSafety = (
    documentNumber,
    documentType,
    user
) => {
    const urlParams = `?documentType=${documentType}&documentNumber=${documentNumber}&page=1&pageSize=10&user=${user}`;
    const urlQuery = `${URL_BACK}/certificadocredito/api/v1/credits/peacedmind-pdf${urlParams}`;
    return axiosInstance.get(urlQuery);
};

export const getAccountStatement = async (userDocument, userDocumentType) => {
    const urlParams = `?documentType=${userDocumentType}&page=1&documentNumber=${userDocument}&pageSize=50`;
    const urlQuery = `${URL_BACK}/certificadocredito/api/v1/credits/account-status${urlParams}`;
    return axiosInstance.get(urlQuery);
};

export const generatePDFAccountStatus = (requestData) => {
    return axiosInstance.post(
        `${URL_BACK}/certificadocredito/api/v1/credits/account-pdf`,
        requestData
    );
};

export const generatePDFDebtCertificate = (requestData) => {
    return axiosInstance.post(
        `${URL_BACK}/certificadocredito/api/v1/credits/debt-pdf`,
        requestData
    );
};
